/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddonProvisionProject200Response
 */
export interface AddonProvisionProject200Response {
    /**
     * 
     * @type {boolean}
     * @memberof AddonProvisionProject200Response
     */
    error?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProject200Response
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProject200Response
     */
    projectId?: string | null;
}

/**
 * Check if a given object implements the AddonProvisionProject200Response interface.
 */
export function instanceOfAddonProvisionProject200Response(value: object): value is AddonProvisionProject200Response {
    return true;
}

export function AddonProvisionProject200ResponseFromJSON(json: any): AddonProvisionProject200Response {
    return AddonProvisionProject200ResponseFromJSONTyped(json, false);
}

export function AddonProvisionProject200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonProvisionProject200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
        'message': json['message'] == null ? undefined : json['message'],
        'projectId': json['projectId'] === undefined ? undefined : json['projectId'] === null ? null : json['projectId'],
    };
}

export function AddonProvisionProject200ResponseToJSON(json: any): AddonProvisionProject200Response {
    return AddonProvisionProject200ResponseToJSONTyped(json, false);
}

export function AddonProvisionProject200ResponseToJSONTyped(value?: AddonProvisionProject200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
        'message': value['message'],
        'projectId': value['projectId'],
    };
}

